export const OPEN_CREATE_SENDER_MODAL = 'OPEN_CREATE_SENDER_MODAL';
